// extracted by mini-css-extract-plugin
export default {"uploadFileButton":"PersonalPayLinkCreate_uploadFileButton__z+Epu","action":"PersonalPayLinkCreate_action__DKZM5"};